export const messages = {
  title: {
    id: 'admin/promotions.form.campaign.audience.section.title',
  },
  subtitle: {
    id: 'admin/promotions.form.campaign.audience.section.subtitle',
  },
  view: {
    add: {
      id: 'admin/promotions.form.campaign.audience.view.add',
    },
    description: {
      id: 'admin/promotions.form.campaign.audience.view.description',
    },
    item: {
      id: 'admin/promotions.form.utils.item-label',
    },
  },
  editor: {
    subtitle: {
      id: 'admin/promotions.form.campaign.audience.editor.subtitle',
    },
    moreInformation: {
      id: 'admin/promotions.form.campaign.audience.editor.more-information',
    },
    label: {
      id: 'admin/promotions.form.campaign.audience.editor.label',
    },
    goToAudiences: {
      id: 'admin/promotions.form.campaign.audience.editor.navigate-button',
    },
  },
  validation: {
    required: {
      id: 'admin/promotions.form.validation.select-an-option',
    },
    addRequired: {
      id: 'admin/promotions.form.campaign.audience.validation.required',
    },
  },
}
